













import {
    Vue, Component, Prop, Mixins,
} from 'vue-property-decorator'

@Component
export default class UpperLevel extends Vue {
    @Prop({default: ''}) current!: string

    @Prop({default: ''}) superior!: string

    @Prop({default: false}) add!: boolean

    @Prop({default: true}) fixed!: boolean

    backToList() {
        let params = JSON.parse(window.localStorage.getItem(this.current) || '{}')
        if (params) {
            let source = params.source || this.superior
            if (!this.add) {
                this.$router.push({name: source, params, query: params.query})
            } else {
                this.$router.push({name: source, query: params.query})
            }
            window.localStorage.removeItem(this.current)
        } else {
            this.$router.push({name: this.superior})
        }
    }
}
